import React from "react";
import { Link } from "react-router-dom";
import TransferCard from "../transfers/TransferCard";
import { useTransfers } from "../../hooks/useTransfers";
import { useTranslation } from "../../hooks/useTranslation";
import { hub } from "./hubSurface";

const HubTransfers: React.FC = () => {
  const { t, isRTL } = useTranslation();
  const { data, isLoading, isError } = useTransfers({
    important: true,
    limit: 6,
    offset: 0,
  });

  const transfers = data?.data ?? [];

  return (
    <section aria-labelledby="hub-transfers-heading">
      <div className="mb-3.5 flex items-center justify-between gap-3">
        <h2
          id="hub-transfers-heading"
          className={`text-base font-semibold tracking-tight ${hub.ink}`}
        >
          {t("hub.transfersTitle")}
        </h2>
        <Link
          to="/transfers?important=1"
          className={`shrink-0 text-xs font-medium ${hub.accent} hover:opacity-80`}
        >
          {t("hub.seeAll")}
        </Link>
      </div>

      {isLoading && (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={i}
              className="h-36 animate-pulse rounded-xl border border-[#e6e4df] bg-[#f6f5f2]"
            />
          ))}
        </div>
      )}

      {isError && (
        <p className={`rounded-xl border ${hub.border} bg-white px-4 py-6 text-center text-sm ${hub.mute}`}>
          {t("hub.transfersError")}
        </p>
      )}

      {!isLoading && !isError && transfers.length === 0 && (
        <p className={`rounded-xl border ${hub.border} bg-white px-4 py-6 text-center text-sm ${hub.mute}`}>
          {t("hub.transfersEmpty")}
        </p>
      )}

      {!isLoading && transfers.length > 0 && (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
          {transfers.map((transfer) => (
            <TransferCard key={transfer.id} transfer={transfer} rtl={isRTL} />
          ))}
        </div>
      )}
    </section>
  );
};

export default HubTransfers;
